module.exports = __webpack_public_path__ + "static/media/v1_transparent.604d73b1.png";